import { useMemo } from "react";

export function StarField({ count = 60, className = "" }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        dur: Math.random() * 4 + 2,
        op: Math.random() * 0.6 + 0.3,
        delay: Math.random() * 4,
      })),
    [count]
  );
  return (
    <div className={`starfield ${className}`} aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            "--dur": `${s.dur}s`,
            "--op": s.op,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
